import { z } from "zod";

import { DEFAULT_LOCALE, DEFAULT_TRANSLATION_SETTINGS, SUPPORTED_LOCALES } from "../constants";

export const translationSettingsSchema = z.object({
  enabled: z.boolean(),
  fallbackLocale: z.literal(DEFAULT_LOCALE),
  locale: z.union([z.literal(SUPPORTED_LOCALES.enUs), z.literal(SUPPORTED_LOCALES.es419)]),
  updatedAt: z.string(),
  version: z.literal(1),
});

export type TranslationSettings = z.infer<typeof translationSettingsSchema>;

export function createDefaultTranslationSettings(): TranslationSettings {
  return {
    ...DEFAULT_TRANSLATION_SETTINGS,
    updatedAt: new Date().toISOString(),
  };
}

export function parseTranslationSettings(value: unknown): TranslationSettings {
  const parsed = translationSettingsSchema.safeParse(value);

  if (parsed.success) {
    return parsed.data;
  }

  return createDefaultTranslationSettings();
}
